module.exports = __webpack_public_path__ + "assets/img/collect-cards-price.4f101705.png";